import { graphConstants } from '../constants';
import { graphRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const graphActions = {}

graphActions.GetGraphsData = () => {
  return dispatch => {
    dispatch(request())
    graphRequests.GetGraphsData()
      .then(
        graphData => dispatch(success(graphData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() { 
    return { type: graphConstants.GRAPHS_REQUEST }
  }

  function success(graphData) { 
    return { type: graphConstants.GRAPHS_SUCCESS, graphData } 
  }

  function failure(error) { 
    return { type: graphConstants.GRAPHS_FAILURE, error } 
  }
}
